import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import iView from 'iview'
import ElementUI from 'element-ui';
import particles from 'particles.js'


import vueQuillEditor from "vue-quill-editor"; // 引入富文本工具
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
Vue.use(vueQuillEditor);

// import 'iview/src/styles/index.less'
import NProgress from 'nprogress'; // Progress 进度条
import 'nprogress/nprogress.css';// Progress 进度条 样式
import 'normalize.css/normalize.css';// normalize.css 样式格式化
import 'element-ui/lib/theme-chalk/index.css';
import './assets/icons' // icon
import './assets/css/common.css' // icon
import './assets/css/scrollbar.css' // icon
import './assets/css/reset.css' // icon
import   './utils/dialogDrag.js'
import './permission'

import permission from './directive/permission'

//
// // 引入echarts 这种引入体积过大，目前在需要页面中按需求引入
// import echarts from 'echarts'
// Vue.prototype.$echarts = echarts;

Vue.use(iView);
Vue.use(ElementUI);
Vue.use(particles);




NProgress.configure({});
Vue.config.productionTip = false;

import { parseTime, resetForm, addDateRange, download } from "@/utils/common";
import {postRequest} from "./utils/api";
import {postKeyValueRequest} from "./utils/api";
import {putRequest} from "./utils/api";
import {deleteRequest} from "./utils/api";
import {getRequest} from "./utils/api";
import { getDicts } from "@/api/sys/dict";


// 全局方法挂载
Vue.prototype.getDicts = getDicts
Vue.prototype.postRequest = postRequest;
Vue.prototype.putRequest = putRequest;
Vue.prototype.deleteRequest = deleteRequest;
Vue.prototype.getRequest = getRequest;
Vue.prototype.resetForm = resetForm;

Vue.use(permission);


new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js